import { BillingCardProps } from '../../components/BillingCard/BillingCard';

export const billingData: BillingCardProps[] = [
  {
    title: 'Standard',
    projects: 'Up to 10 projects',
    reports: '2 Due Diligence reports',
    pricePerCredit: 1200,
    customTemplate: 0,
    numOfConsultations: 0,
    price: 0,
  },
  {
    title: 'Pro',
    projects: 'Up to 30 projects per month',
    reports: '2 Due Diligence reports',
    pricePerCredit: 1000,
    customTemplate: 1,
    numOfConsultations: 2,
    price: 1500,
  },
  {
    title: 'Elite',
    projects: 'Up to 100 projects per month',
    reports: '3 Due Diligence reports',
    pricePerCredit: 800,
    customTemplate: 2,
    numOfConsultations: 5,
    price: 4500,
  },
];
